import { CommonFragments } from './common.fragments';

export class ContributorsDetractorsFragments {
  /*
   * GraphQL Fragment for the Contributors and Detractors Exhibit
   */
  public static readonly contributorsDetractorsFragment = `
    contributorsDetractorsExhibit {
      asOfDate
      availablePriorDates
      contributorsList {
        timePeriodName
        values {
          name
          sectorName
          percentTotalNetAssets
        }
      }
      detractorsList {
        timePeriodName
        values {
          name
          sectorName
          percentTotalNetAssets
        }
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;
}
